<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    :width="width"
    :height="height"
    xml:space="preserve"
    viewBox="0 0 612 612"
    role="presentation"
    :fill="iconColor">
    <g>
      <path d="M313.49,306H68.373v-62.997c0-4.97,4.029-9,9-9H271.93c3.409,0,6.525,1.926,8.05,4.975L313.49,306z M176.368,144.008
        v-35.999h-62.997v35.999H176.368z M113.371,162.007v62.997h62.997v-62.997H113.371z M609.979,329.663l-44.802,81.248
        c-31.663,57.421-92.047,93.08-157.618,93.08H91.95c-19.368,0-36.563-12.394-42.688-30.769L0.469,326.845
        C-1.474,321.017,2.864,315,9.006,315h593.977C610.554,315,614.742,323.778,609.979,329.663z M152.987,392.375
        c0-9.644-7.816-17.46-17.459-17.46c-9.643,0-17.459,7.816-17.459,17.46c0,9.643,7.817,17.459,17.459,17.459
        C145.17,409.834,152.987,402.018,152.987,392.375z M224.984,392.375c0-9.644-7.817-17.46-17.46-17.46
        c-9.643,0-17.459,7.816-17.459,17.46c0,9.643,7.817,17.459,17.459,17.459C217.167,409.834,224.984,402.018,224.984,392.375z
         M296.98,392.375c0-9.644-7.816-17.46-17.459-17.46c-9.643,0-17.459,7.816-17.459,17.46c0,9.643,7.817,17.459,17.459,17.459
        C289.164,409.834,296.98,402.018,296.98,392.375z"/>
    </g>
  </svg>
</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    width: {
      type: [Number, String],
      default: '32px'
    },
    height: {
      type: [Number, String],
      default: '32px'
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
